import React from "react";
import { Container } from "@material-ui/core";
import ContentLoader from "react-content-loader";
import useSchedule from "../../../hooks/useSchedule";
import SwipeableViews from 'react-swipeable-views';
import TableAssistance from "../../TableAssistance/TableAssistance";
import config from "../../../config";

export default function Assistance({ language }) {

  const url = `${config.API_URL}/_services/get_driver_schedule.php?id=${localStorage.getItem("user_id")}`;

  const { isloading, error, data, doFetch } = useSchedule(url);

  console.log(data, isloading);

  return (
    <Container
      style={{
        position: "fixed",
        height: "100vh",
        paddingLeft: "12px",
        paddingRight: "12px",
      }}
    >
      {isloading === true && data !== null ? (
        <ContentLoader />
      ) : (
        <>
          <SwipeableViews
            axis={'x'}
            index={0}
            enableMouseEvents
          >
            <TableAssistance
              language={language}
              data={data?.data_new ?? []}
              data_total={data?.total_new === "" ? 0 : data?.total_new}
              title={language === "en" ? "Current week" : "Semana Actual"}
            />
            <TableAssistance
              language={language}
              data={data?.data_old ?? []}
              data_total={data?.total_old === "" ? 0 : data?.total_old}
              title={language === "en" ? "Last week" : "Semana Pasada"}
            />
          </SwipeableViews>
        </>
      )}
    </Container>
  )

}